var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Arrow-Up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Arrow-Up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Up_2",
    className: "st0",
    d: "M7.2,13.4c-0.2,0.2-0.2,0.5,0,0.7l0.7,0.7c0.2,0.2,0.5,0.2,0.7,0l3.4-3.3l3.4,3.3 c0.2,0.2,0.5,0.2,0.7,0l0.7-0.7c0.2-0.2,0.2-0.5,0-0.7l-4.5-4.3c-0.2-0.2-0.5-0.2-0.7,0L7.2,13.4L7.2,13.4z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/up-arrow.65d0caee787f6c008d38dfb5421d37cc.svg";